import styled from '@emotion/styled';
import Card from 'storybookConfig/stories/cells/Card';
import { ThemeBreakpoints } from 'storybookConfig/stories/theme';

/* A floating card on the plasma field: the website's card radius, as the auth field's frame. */
export const OnboardingCard = styled(Card)`
  padding: 24px;
  border-radius: ${({ theme }) => theme.radius.card};

  @media screen and (${ThemeBreakpoints.md}) {
    padding: 48px 80px;
  }
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 16px;

  > :not(:last-child) {
    padding: inherit;
  }

  > :last-child {
    align-self: stretch;
    justify-content: center;
  }

  @media screen and (${ThemeBreakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    > :not(:last-child) {
      padding: revert;
    }

    > :last-child {
      align-self: auto;
      justify-content: initial;
    }
  }
`;

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media screen and (${ThemeBreakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ReviewItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  background-color: ${({ theme }) => theme.color.bodyBackground};
  border-radius: 8px;
`;
